import { lazy } from 'react';
import { STEPPER_KEYS } from './index';

const PersonalVerification = lazy(() => import('../components/PersonalVerificationContainer'));
const CySecAccountSettings = lazy(() => import('../containers/CySecAccountSettingsContainer'));
const UserExperience = lazy(() =>
  import('modules/cySecQuestionnaire/containers/UserExperienceContainer'),
);
const UploadDocuments = lazy(() => import('../containers/UploadDocumentsContainer'));

export const VERIFICATION_CYSEC_STEPS = [
  {
    key: STEPPER_KEYS.PERSONAL,
    passed: false,
    title: 'profile:cySecVerification.personalDetails.title',
    tooltipContent: 'profile:cySecVerification.tooltip.whyDoWeAskThis',
    sectionComponent: PersonalVerification,
    hasReadOnlyMode: false,
  },
  {
    key: STEPPER_KEYS.EXPERIENCE,
    passed: false,
    title: 'profile:cySecVerification.questionnaire.title',
    tooltipContent: 'profile:cySecVerification.tooltip.whyDoWeAskThis',
    sectionComponent: UserExperience,
    hasReadOnlyMode: true,
  },
  {
    key: STEPPER_KEYS.ACCOUNT,
    passed: false,
    title: 'profile:cySecVerification.accountSettings.title',
    tooltipContent: 'profile:cySecVerification.tooltip.whyDoWeAskThis',
    sectionComponent: CySecAccountSettings,
    hasReadOnlyMode: true,
  },
  {
    key: STEPPER_KEYS.DOCUMENTS,
    passed: false,
    title: 'profile:cySecVerification.identityVerification.title',
    tooltipContent: 'profile:cySecVerification.tooltip.whyDoWeAskThis',
    sectionComponent: UploadDocuments,
    hasReadOnlyMode: false,
  },
];
